import WordProvider from './WordProvider';
import Main from './Main';
import Footer from './Footer';

const App = () => {
  return (
    <WordProvider>
      <div className="app">
        <Main />
        <Footer />
      </div>
    </WordProvider>
  );
};

export default App;
